import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AddRoadIcon from '@mui/icons-material/AddRoad'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import GridViewIcon from '@mui/icons-material/GridView'
import ReceiptIcon from '@mui/icons-material/Receipt'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import React from 'react'
import '../HorizontalNavSections.css'

const MainNavigationSection = ({
  handleNavigation,
  selectedPath,
  isLoading,
  horizontal: _horizontal,
}: {
  handleNavigation: any
  selectedPath: any
  isLoading: any
  horizontal?: boolean
}) => {
  const theme = useTheme()
  //////////////////////// Grouped navigation ///////////////////////////
  const [anchorEl, setAnchorEl] = React.useState(null)
  const listOpen = Boolean(anchorEl)
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }
  const handleMenuNavigation = path => {
    handleNavigation(path)
    handleMenuClose()
  }
  //////////////////////////////////////////////////////////////////////

  const navItems = [
    {
      label: 'Dashboard',
      path: 'dashboard',
      color: 'rgb(5, 190, 113)',
      icon: <GridViewIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Accounting',
      path: 'accounting',
      color: 'rgba(107, 185, 240, 1)',
      icon: <ReceiptIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Team Tasks',
      path: 'teamtasks',
      color: 'rgb(247, 63, 236)',
      icon: <TaskAltIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'New Client Onboards',
      path: 'nco',
      color: 'rgb(52, 211, 145)',
      icon: <AddRoadIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Monthly Task Board',
      path: 'mtb',
      color: 'rgb(20, 119, 248)',
      icon: <CalendarMonthIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Projects',
      path: 'projects',
      color: 'rgb(245, 108, 53)',
      icon: <RocketLaunchIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Boards',
      path: 'boards',
      color: 'rgb(247, 63, 134)',
      icon: <AccountTreeIcon sx={{ height: 22, width: 22 }} />,
    },
  ]

  return (
    <List
      disablePadding
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        m: 0, // remove default margins
        transition: 'all 0.2s ease',
      }}
    >
      {!isSmallScreen &&
        navItems.map(item => {
          const isSelected = item.path === selectedPath.replace(/^\//, '')

          return (
            <ListItem
              className={isSelected ? 'list-button-menu' : ''}
              key={item.label}
              disablePadding
              sx={{
                display: 'inline-flex',
                width: 'auto',
              }}
            >
              <ListItemButton
                disableGutters
                onClick={() => handleNavigation(item.path)}
                sx={{
                  minWidth: 50,
                  minHeight: 50,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'transparent',
                  transition: 'transform 0.2s ease-in-out',
                  // Icon styling - default muted, colored when selected or hovered
                  '& .MuiSvgIcon-root': {
                    color: isSelected ? item.color : theme.palette.text.primary,
                    transition: 'color 0.2s ease-in-out, transform 0.2s ease-in-out',
                  },
                  // Hover on the entire button triggers icon color change
                  '&:hover': {
                    backgroundColor: 'transparent',
                    transform: 'scale(1.2)',
                    '& .MuiSvgIcon-root': {
                      color: item.color,
                    },
                  },
                }}
                disabled={isLoading}
              >
                <Tooltip
                  enterDelay={500}
                  leaveDelay={0}
                  title={<Typography p={1}>{item.label}</Typography>}
                  placement="top"
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                </Tooltip>
              </ListItemButton>
            </ListItem>
          )
        })}
    </List>
  )
}

export default MainNavigationSection
